<template>
    <div class="zebra-crossing-detail">
        <!--  表单明细 -->
        <el-form :model="detail">
            <div class="zebra-item">
                <div class="zebra-item_tit">问题登记单</div>
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="所属公司：">{{ detail.company | tableVal(companyList,'n') }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="报告人：">{{ detail.requester }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="问题分类：">{{ detail.category | tableVal(problemList,'t') }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="已知错误：">{{ detail.known | tableVal(knownList) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="问题标题：">{{ detail.title }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="问题来源：">{{ detail.origin | tableVal(problemOrigin) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="优先级：">{{ detail.priority | tableVal(priority) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="影响范围：">{{ detail.influence | tableVal(influence) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="标签：">
                            <span v-for="item in detail.label" style="margin-right: 10px;">{{ item }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="风险等级：">
                            {{detail.risk | tableVal(risk)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="项目名称：">{{detail.projectName | tableVal(projectName)}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="服务请求：">{{detail.serviceClass | tableVal(serviceClass)}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="完成程度：">
                            {{detail.completionDegree|tableVal(completionDegree)}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="环境：">{{detail.env | tableVal(env)}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="完成时间：">
                            {{detail.endTime}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="上传附件：">
                            <ul>
                                <li v-for="item in detail.attachment" >
                                    <a :href="item.url" style="color: #1890EF">{{ item.name }}</a>
                                    <span>上传时间:&emsp;{{item.uploadTime?item.uploadTime:'无'}}</span>
                                    <span class="preview" @click="previewEvent(item)">预览</span>
                                </li>
                            </ul>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="影响说明：">{{ detail.influenceDes }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="根本原因：">{{ detail.cause }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="问题症状：">{{ detail.symptom }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="规避措施：">{{ detail.avoid }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="解决方案：">{{ detail.solution }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="详细描述：">
                            <span v-html="detail.description"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { knownList } from "./problem.config"
    export default {
        props:{
            detail:Object,
            companyList:Array,
            problemList:Array
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 问题来源
            problemOrigin(){
                return this.dictionary.problem_origin;
            },
            // 紧急度
            emergency(){
                return this.dictionary.emergency;
            },
            // 优先级
            priority(){
                return this.dictionary.priority;
            },
            // 难易程度
            complexity(){
                return this.dictionary.complexity;
            },
            // 影响范围
            influence(){
                return this.dictionary.influence;
            },
            //风险等级
            risk(){
                return this.dictionary.problem_risk;
            },
            completionDegree(){
                return this.dictionary.completion_degree
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },
        },
        data() {
            return {
                knownList
            }
        },
        created() {

        },
        methods: {
            previewEvent(row){
                // console.log(row)
                this.$router.push({
                    name:'Preview',
                    path:'/preview',
                    query: {
                        file:row
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.preview{
    color:blue;
    cursor: pointer;
    margin-left: 10px;
}
</style>
